import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  BackButton,
  InputWithLabel,
  RadioButton,
} from "../../../components/micro";
import { headChat } from "../../../assets/image";
import ReactSelect from "react-select";
import { InputError } from "../../../commons/MicroComponents";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import ConfigurationShares from "../components/ConfigurationShares";
import NewShareholder from "../components/NewShareholder";
import {
  createServicesRequest,
  serviceRequestsUsers,
} from "../../../redux/serviceRequest/slice";

const AllotmentTransferNewShareholder = () => {
  const [noOfShareholder, setNoOfShareholder] = useState(1);
  const [newShareholderNameArray, setNewShareholderArray] = useState([]);
  const [newSharesAmountArray, setNewSharesAmountArray] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const user_id = location?.state?.user_id;
  const company_id = location?.state?.company_id;
  const service = location?.state?.service;
  const buttonRef = useRef(null);

  const createServicesRequestData = useSelector(
    (store) => store?.serviceRequestData?.createServicesRequestStatus?.data
  );
  const createServicesRequestLoading = useSelector(
    (store) => store?.serviceRequestData?.loading
  );
  const shareholderData = useSelector(
    (store) => store?.serviceRequestData?.serviceRequestsUsersStatus?.data
  );

  useEffect(() => {
    if (!shareholderData?.length) {
      dispatch(
        serviceRequestsUsers({ type: "shareholder", company_id: company_id })
      );
    }
  }, [dispatch]);

  useEffect(() => {
    if (shareholderData?.length) {
      const data = shareholderData?.map((e) => ({ ...e, amount: 0 }));
      setNewSharesAmountArray(data);
    }
  }, [shareholderData]);

  // Update New Shareholder Array
  const updateNewShareholderArray = useCallback(
    (index, field, value) => {
      setNewSharesAmountArray((prev) =>
        prev.map((item, i) =>
          i === index ? { ...item, [field]: value } : item
        )
      );
    },
    [setNewSharesAmountArray]
  );

  // handle Submit
  const handleSubmit = (value) => {
    const payload = {
      details: {
        allotment_transfer_type: value.allotment_transfer_type.value,
        new_shareholder: value.new_shareholder,
        adjusting_total_shares: value?.adjusting_total_shares,
        ...(value.new_shareholder && {
          new_shareholder: newShareholderNameArray,
        }),
        ...(value.adjusting_total_shares && {
          paid_up_capital: value.paid_up_capital,
          issued_share_capital: value.issued_share_capital,
          total_number_of_shares: value.total_number_of_shares,
        }),
        new_shares_amount: newSharesAmountArray,
      },
      amount:
        service?.service_requests_count < service?.detail?.no_of_free_request
          ? 0
          : service?.detail?.price ?? 0,
      user_id: user_id,
      company_id: company_id,
      service_id: service?.id,
    };
    dispatch(createServicesRequest(payload)).then((res) => {
      if (res.type !== "createServicesRequest/fulfilled") return;
      const { service_requests_count, detail } = service || {};
      const price = detail?.price || 0;
      if (
        service_requests_count < service?.detail?.no_of_free_request ||
        price <= 0
      ) {
        navigate("/approver");
      } else if (buttonRef.current) {
        buttonRef.current.click();
      } else {
        navigate("/approver");
      }
    });
  };

  return (
    <div className="space-y-5">
      <BackButton
        onClick={() => {
          navigate("/service");
        }}
      />
      <div className="flex items-center space-x-5 border-b-2 border-secondary_grey pb-7">
        <img src={headChat} alt="img" />
        <div className="space-y-2 font-ebGaramond">
          <p className="text-xl">We see that you will need a request on:</p>
          <p className="text-3xl">
            Allotment/Transfer of Shares to Existing/New Shareholders
          </p>
        </div>
      </div>

      {/* Payment Button */}
      <a
        className="hidden"
        ref={buttonRef}
        href={createServicesRequestData?.data?.url}
      >
        Pay Now
      </a>
      <Formik
        initialValues={{
          allotment_transfer_type: "",
          new_shareholder: false,
          adjusting_total_shares: false,
          paid_up_capital: "",
          issued_share_capital: "",
          total_number_of_shares: "",
        }}
        validationSchema={Yup.object().shape({
          allotment_transfer_type: Yup.object()
            .nullable()
            .required("Allotment/Transfer type is required"),
          new_shareholder: Yup.boolean().notRequired(),
          adjusting_total_shares: Yup.boolean().notRequired(),
          paid_up_capital: Yup.string().when("adjusting_total_shares", {
            is: true,
            then: Yup.string().required("Paid up capital is required"),
            otherwise: Yup.string().notRequired(),
          }),
          issued_share_capital: Yup.string().when("adjusting_total_shares", {
            is: true,
            then: Yup.string().required(
              "Issued Share Capital capital is required"
            ),
            otherwise: Yup.string().notRequired(),
          }),
          total_number_of_shares: Yup.string().when("adjusting_total_shares", {
            is: true,
            then: Yup.string().required("Total Number of Shares is required"),
            otherwise: Yup.string().notRequired(),
          }),
        })}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          setFieldValue,
        }) => (
          <Form className="space-y-5">
            <div className="space-y-3 border-b-2 border-secondary_grey pb-3">
              <p className="text-2xl font-ebGaramond">
                Let us guide u though the process:
              </p>
              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                <span>1.</span>
                <p>Let us know which changes you will need</p>
              </div>
              <p className="text-sm">Select the type of service you need</p>
              {/* Allotment/Transfer Type */}
              <ReactSelect
                className={"p-0"}
                id="allotment_transfer_type"
                placeholder="Allotment/Transfer Type"
                options={[
                  { value: "allotment", label: "Allotment" },
                  { value: "transfer", label: "Transfer" },
                ]}
                isLoading={false}
                value={values.allotment_transfer_type}
                isClearable
                onChange={(option) => {
                  setFieldValue("allotment_transfer_type", option);
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    border: `1px solid ${
                      errors.allotment_transfer_type &&
                      touched.allotment_transfer_type
                        ? "red"
                        : "#0000003B"
                    }`,
                    borderRadius: "0.3rem",
                    paddingTop: "2px",
                    paddingBottom: "2px",
                    boxShadow: "none",
                    "&:hover": {
                      border: "1px solid #cdddeb",
                    },
                  }),
                }}
              />
              {errors.allotment_transfer_type &&
              touched.allotment_transfer_type ? (
                <InputError errorTitle={errors.allotment_transfer_type} />
              ) : null}

              {values.allotment_transfer_type?.value && (
                <div className="space-y-3">
                  <p>Will there be new shareholder?</p>
                  <RadioButton
                    label={"No"}
                    type="radio"
                    id="new_shareholder"
                    name="new_shareholder"
                    value={false}
                    checked={values.new_shareholder === false}
                    onChange={() => setFieldValue("new_shareholder", false)}
                    onBlur={handleBlur}
                    className={""}
                  />
                  <RadioButton
                    label={"Yes"}
                    type="radio"
                    id="new_shareholder"
                    name="new_shareholder"
                    value={true}
                    checked={values.new_shareholder === true}
                    onChange={() => setFieldValue("new_shareholder", true)}
                    onBlur={handleBlur}
                    className={""}
                  />
                </div>
              )}
              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                <span>2.</span>
                <p>Configure cap table</p>
              </div>
              {values.allotment_transfer_type?.value && (
                <>
                  <div className="space-y-3">
                    <p>Will you adjusting the number of total shares?</p>
                    <RadioButton
                      label={"No"}
                      type="radio"
                      id="adjusting_total_shares"
                      name="adjusting_total_shares"
                      value={false}
                      checked={values.adjusting_total_shares === false}
                      onChange={() =>
                        setFieldValue("adjusting_total_shares", false)
                      }
                      className={""}
                    />
                    <RadioButton
                      label={"Yes"}
                      type="radio"
                      id="adjusting_total_shares"
                      name="adjusting_total_shares"
                      value={true}
                      checked={values.adjusting_total_shares === true}
                      onChange={() =>
                        setFieldValue("adjusting_total_shares", true)
                      }
                      className={""}
                    />
                  </div>
                  {/* new shareholder  */}
                  {values.new_shareholder && (
                    <NewShareholder
                      noOfShareholder={noOfShareholder}
                      setNoOfShareholder={setNoOfShareholder}
                      newShareholderNameArray={newShareholderNameArray}
                      setNewShareholderArray={setNewShareholderArray}
                    />
                  )}
                  {/* Configuration Shares */}
                  {values.adjusting_total_shares && (
                    <ConfigurationShares
                      values={values}
                      errors={errors}
                      touched={touched}
                      handleBlur={handleBlur}
                      handleChange={handleChange}
                    />
                  )}

                  <p className="pt-3 border-t-2 border-secondary_grey">
                    Configuration Shares Within Shareholders
                  </p>
                  {newSharesAmountArray?.map((element, index) => {
                    return (
                      <div className="grid grid-cols-2 gap-3">
                        <div className="text-sm space-y-1">
                          <p>Shareholder Names:</p>
                          <p className="text-theme capitalize">
                            {element?.user?.full_name ?? "-"}
                          </p>
                        </div>
                        <InputWithLabel
                          className={"border"}
                          label={"New Shares Amount"}
                          idFromName={element?.user?.full_name}
                          type={"number"}
                          value={element?.amount}
                          onChange={(e) =>
                            updateNewShareholderArray(
                              index,
                              "amount",
                              e.target.value
                            )
                          }
                        />
                      </div>
                    );
                  })}
                </>
              )}
              <p>Will you adjusting the number of total shares?</p>
              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                <span>3.</span>
                <p>SGCorpHub preparing the relevant resolution</p>
              </div>
              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                <span>4.</span>
                <p>Obtain signed resolution</p>
              </div>
              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                <span>5.</span>
                <p>
                  We will lodge the changes to ACRA for the change of Company
                  Name
                </p>
              </div>
              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                <span>6.</span>
                <p>(If Need) IRAS stamp duty payment</p>
              </div>
              <p className="text-sm">
                Once the request is opened. You can easily manage it over at
                “On-Going” service page.
              </p>
            </div>
            <div className="flex items-center justify-between space-x-1  bg-light_primary_shades rounded-lg px-4 py-3">
              <p className="font-semibold">Total Payable :</p>
              <div>
                <p className="text-xs">
                  {service?.service_requests_count}/
                  {service?.detail?.no_of_free_request ?? 0} used
                </p>
                <p>
                  {service?.service_requests_count >=
                  service?.detail?.no_of_free_request
                    ? service?.detail?.price
                    : "Free"}
                </p>
              </div>
            </div>
            <div className="box !rounded-xl flex items-center justify-between">
              <button
                className={`${
                  createServicesRequestLoading
                    ? "btn-outline-disabled"
                    : "btn-theme"
                } uppercase`}
                type="submit"
                disabled={createServicesRequestLoading}
              >
                {createServicesRequestLoading
                  ? "Loading..."
                  : "Proceed with request"}
              </button>
              <div>
                <p className="text-xs">Total:</p>
                <p>
                  {service?.service_requests_count >=
                  service?.detail?.no_of_free_request
                    ? service?.detail?.price
                    : "Free"}
                </p>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AllotmentTransferNewShareholder;
